// EmergencyDAO.ts
import { useApiStore } from '@/stores/apiStore';
import { EmergencyApi } from '@/../generated-client/apis/EmergencyApi';
import { EmergencyMessageApi } from '@/../generated-client/apis/EmergencyMessageApi';

let emergencyApi: EmergencyApi | null = null;
let emergencyMessageApi: EmergencyMessageApi | null = null;
let lastConfig: unknown = null;

function getEmergencyApi(): EmergencyApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (emergencyApi === null || lastConfig !== apiConfig) {
    emergencyApi = new EmergencyApi(apiConfig);
    lastConfig = apiConfig;
  }

  return emergencyApi;
}

function getEmergencyMessageApi(): EmergencyMessageApi {
  const { apiConfig } = useApiStore.getState();

  if (emergencyMessageApi === null || lastConfig !== apiConfig) {
    emergencyMessageApi = new EmergencyMessageApi(apiConfig);
    lastConfig = apiConfig;
  }
  return emergencyMessageApi;
}

export async function getAllEmergencyByID(
  emergencyId: string,
  orgCode: string,
) {
  const api = getEmergencyApi();
  return api.apiEmergencyGetAllByIdV1Get({ emergencyId /*, orgCode */ });
}

export async function getAllEmergenciesByUser(userAuthId: string) {
  const api = getEmergencyApi();
  return api.apiEmergencyGetEmergencyHistoryByAuthIdPost({
    authIdRequest: { auth_id: userAuthId },
  });
}

export async function sendMessage(
  emergencyId: string,
  orgCode: string,
  content: string,
  messageKind: string,
) {
  const api = getEmergencyMessageApi();
  return api.apiEmergencyMessageAddPost({
    emergencyMessageSelfCreate: {
      content: content,
      degrees_bearing: null,
      emergency_id: emergencyId,
      latitude: null,
      longitude: null,
      message_kind: messageKind,
      meters_per_second_speed: null,
    },
  });
}

export async function deleteEmergency(emergencyId: string) {
  const api = getEmergencyApi();
  return api.apiEmergencyDeleteAllObjectsDelete({
    emergencySafeguardDelete: {
      emergency_id: emergencyId,
    },
  });
}
